import { useMutation, useQueryClient } from 'react-query';
import queries from '../queries';

const useProcessSos = (callbacks = {}) => {
  return useMutation(
    () => {
      return queries.crm.processSos.query();
    },
    {
      ...callbacks,
      onSuccess: ({ data }, variables) => {
        if (typeof callbacks.onSuccess === 'function') callbacks.onSuccess(data, variables);
      },
    }
  );
};

const useProcessHubspot = (callbacks = {}) => {
  return useMutation(
    () => {
      return queries.crm.processHubspot.query();
    },
    {
      ...callbacks,
      onSuccess: ({ data }, variables) => {
        if (typeof callbacks.onSuccess === 'function') callbacks.onSuccess(data, variables);
      },
    }
  );
};

const useConvertToSuperCompany = (callbacks = {}) => {
  const queryClient = useQueryClient();
  return useMutation(
    ({ parent, child }) => {
      return queries.crm.convertToSuperCompany.query(parent, child);
    },
    {
      ...callbacks,
      onSuccess: ({ data }, variables) => {
        queryClient.invalidateQueries([queries.companies.users.key, variables.companyId]);
        queryClient.invalidateQueries([queries.companies.stats.key, variables.companyId]);
        queryClient.invalidateQueries([queries.companies.sales.key, variables.companyId]);
        queryClient.invalidateQueries([queries.users.getAccountQuota.key, variables.accountId]);
        queryClient.invalidateQueries([queries.companies.list.key]);
        if (typeof callbacks.onSuccess === 'function') callbacks.onSuccess(data, variables);
      },
    }
  );
};

const useSyncHubspotTickets = (callbacks = {}) => {
  const queryClient = useQueryClient();
  return useMutation(
    ({ pipelineId }) => {
      return queries.crm.syncHubspotTickets.query(pipelineId);
    },
    {
      ...callbacks,
      onSuccess: ({ data }, variables) => {
        queryClient.invalidateQueries([queries.crm.hubspotUnmappedTickets.key]);
        queryClient.invalidateQueries([queries.crm.hubspotTickets.key]);
        if (typeof callbacks.onSuccess === 'function') callbacks.onSuccess(data, variables);
      },
    }
  );
};

const useSyncHubspotPipeline = (callbacks = {}) => {
  const queryClient = useQueryClient();
  return useMutation(
    ({ pipelineId }) => {
      return queries.crm.syncHubspotPipeline.query(pipelineId);
    },
    {
      ...callbacks,
      onSuccess: ({ data }, variables) => {
        queryClient.invalidateQueries([queries.crm.hubspotPipelines.key]);
        if (typeof callbacks.onSuccess === 'function') callbacks.onSuccess(data, variables);
      },
    }
  );
};

export default {
  useProcessSos,
  useProcessHubspot,
  useConvertToSuperCompany,
  useSyncHubspotTickets,
  useSyncHubspotPipeline,
};
